import { CHANGE_LANG } from "../types";

const INITIAL_STATE = {
  locale: "en",
};

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case CHANGE_LANG:
      return { ...state, locale: action.locale };
    default:
      return state;
  }
};
